import {select, local} from 'd3-selection';
import {className} from '../../modules/util';
function reset (keep) {
  this.__execs__.axis = {};
  this.__execs__.legend = null;
  if (!this.parent()) this.__execs__.mark = local(); //facet 되었을때는 비우지 않음
  this.__execs__.field = {};
  this.__execs__.regions = null;
  this.__execs__.nodes = null;
  if (!keep) this.__execs__.scale = {};
  if (!this.parent() && this.__execs__.canvas) select(this.container()).selectAll(className('tooltip', true)).remove(); //facet에 의해 여러 tooltip이 생길 수 있으므로 리셋한다.
  return this;
}

export default reset;


// WEBPACK FOOTER //
// ./layouts/default/reset.js